export const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
